export const setTaskTypeSelectedItem = selected => {
  return {
    type: "SET_TASK_TYPE_SELECTED",
    selected
  };
};

export const setTaskCategorySelectedItem = selected => {
  return {
    type: "SET_TASK_CATEGORY_SELECTED",
    selected
  };
};

export const setTaskTypeListFilterTitle = title => {
  return {
    type: "SET_TASK_TYPE_LIST_FILTER_TITLE",
    title
  };
};

export const fetchTaskTypeList = data => ({
  type: "FETCH_TASK_TYPES_LIST",
  payload: data
});

export const fetchNonCategorizedTaskTypeCount = data => ({
  type: "FETCH_NON_CATEGORIZED_TASK_TYPES_COUNT",
  payload: data
});

export const fetchTaskCategoryList = data => ({
  type: "FETCH_TASK_CATEGORIES_LIST",
  payload: data
});

export const initTaskTypeList = () => ({
  type: "INIT_TASK_TYPES_LIST"
});

export const setTaskTypeListPaginationPage = pageNumber => {
  return {
    type: "SET_TASK_TYPES_LIST_PAGINATION_PAGE",
    pageNumber
  };
};

export const setTaskTypeListPageSize = pageSize => {
  return {
    type: "SET_TASK_TYPES_LIST_PAGE_SIZE",
    pageSize
  };
};

export const saveCorrelationTaskType = resp => ({
  type: "SAVE_TASK_TYPE_CORRELATION",
  payload: resp
});

export const toggleBillableTaskType = resp => ({
  type: "TOGGLE_BILLABLE_TASK_TYPE",
  payload: resp
});

export const setTasksList = items => {
  return {
    type: "SET_TASKS_LIST",
    items
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/types.js